import React from "react";

type LoadingDirection = 'previous' | 'next';

interface SmartLoadingIndicatorProps {
  direction: LoadingDirection;
  estimatedCount?: number;
  isRetrying?: boolean;
  retryCount?: number;
  className?: string;
}

export const SmartLoadingIndicator: React.FC<SmartLoadingIndicatorProps> = ({
  direction,
  estimatedCount,
  isRetrying = false,
  retryCount = 0,
  className = "",
}) => {
  const getLoadingMessage = () => {
    if (isRetrying) {
      return retryCount > 0 
        ? `Retrying... (${retryCount})`
        : "Retrying...";
    }

    const directionText = direction === 'previous' ? 'older' : 'newer';
    
    if (estimatedCount && estimatedCount > 0) {
      return `Loading ${estimatedCount} ${directionText} messages...`;
    }
    
    return `Loading ${directionText} messages...`;
  };

  const getIcon = () => {
    if (isRetrying) {
      return "🔄";
    }
    
    return direction === 'previous' ? "⬆️" : "⬇️";
  };

  const getProgressIndicator = () => {
    // Simple animated dots to show activity
    return (
      <div className="flex space-x-1">
        <div className="w-1 h-1 bg-current rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="w-1 h-1 bg-current rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <div className="w-1 h-1 bg-current rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    );
  };

  return (
    <div className={`flex items-center justify-center py-3 ${className}`}>
      <div className="flex items-center space-x-2 text-sm text-muted-foreground">
        <span className="text-base">{getIcon()}</span>
        <span>{getLoadingMessage()}</span>
        {getProgressIndicator()}
      </div>
    </div>
  );
};